export default __webpack_public_path__ + "static/media/2.d3941a48.jpg";